module.exports = __webpack_public_path__ + "static/logo-with-text.257bbffc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-with-text.svg
// module id = 1769
// module chunks = 114276838955818